const auth = angular.module('auth', []);

auth.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'login',
            url: '/login',
            component: 'auth.loginComponent',
            params: { external: true },
            resolve: {
                returnTo: ['$transition$', function ($transition$) {
                    if (!$transition$.redirectedFrom()) {
                        return
                    }

                    return $transition$.redirectedFrom().targetState();
                }]
            }
        },
        {
            name: 'loginWithLink',
            url: '/loginWithLink',
            params: { external: true },
            component: 'auth.loginWithLinkComponent'
        },
        {
            name: 'recover',
            url: '/recuperar',
            params: { external: true },
            component: 'auth.recoverComponent'
        },
        {
            name: 'resend',
            url: '/reenvio',
            params: { external: true },
            component: 'auth.resendComponent'
        },
        {
            name: 'reset',
            url: '/reset',
            params: { external: true },
            component: 'auth.resetComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);